"use client";

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from "framer-motion";
import { ReactNode, RefObject, useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useClickAway, useKeyPressEvent } from "react-use";
export default function SeasonsGridDropdownDesktopWrapper(t0) {
  const $ = _c(23);
  const {
    isOpen,
    setOpen,
    buttonRef,
    children
  } = t0;
  const listRef = useRef(null);
  let t1;
  if ($[0] !== buttonRef || $[1] !== setOpen) {
    t1 = e => {
      if (buttonRef.current && e.target instanceof Node && buttonRef.current.contains(e.target)) {
        return;
      }
      setOpen(false);
    };
    $[0] = buttonRef;
    $[1] = setOpen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useClickAway(listRef, t1);
  let t2;
  if ($[3] !== setOpen) {
    t2 = () => setOpen(false);
    $[3] = setOpen;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useKeyPressEvent("Escape", t2);
  const dropdownRef = useRef(null);
  let t3;
  if ($[5] !== buttonRef || $[6] !== isOpen) {
    t3 = () => {
      if (!isOpen) {
        return;
      }
      if (!buttonRef.current || !dropdownRef.current) {
        return;
      }
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const dropdownEl = dropdownRef.current;
      const width = listRef.current?.offsetWidth ?? dropdownEl.offsetWidth ?? 288;
      const scrollX = window.scrollX;
      const scrollY = window.scrollY;
      const top = buttonRect.bottom + scrollY;
      let left = buttonRect.left + scrollX;
      if (buttonRect.left + width > window.innerWidth - 16) {
        left = buttonRect.right + scrollX - width;
      }
      left = Math.max(16, left);
      dropdownEl.style.top = `${top}px`;
      dropdownEl.style.left = `${left}px`;
    };
    $[5] = buttonRef;
    $[6] = isOpen;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const position = t3;
  let t4;
  let t5;
  if ($[8] !== position) {
    t4 = () => {
      position();
    };
    t5 = [position];
    $[8] = position;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useLayoutEffect(t4, t5);
  let t6;
  let t7;
  if ($[11] !== isOpen || $[12] !== position) {
    t6 = () => {
      if (!isOpen) {
        return;
      }
      const onResize = () => position();
      window.addEventListener("resize", onResize);
      window.addEventListener("scroll", onResize);
      return () => {
        window.removeEventListener("resize", onResize);
        window.removeEventListener("scroll", onResize);
      };
    };
    t7 = [isOpen, position];
    $[11] = isOpen;
    $[12] = position;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  useEffect(t6, t7);
  const [mounted, setMounted] = useState(false);
  let t8;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setMounted(true);
    };
    t9 = [];
    $[15] = t8;
    $[16] = t9;
  } else {
    t8 = $[15];
    t9 = $[16];
  }
  useEffect(t8, t9);
  if (!mounted) {
    return null;
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      left: 0,
      top: 0
    };
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== children || $[19] !== isOpen) {
    t11 = isOpen && <motion.div ref={listRef} role="menu" tabIndex={-1} className="tw-mt-2 tw-w-72 tw-rounded-lg tw-bg-iron-900 tw-p-2 tw-shadow-lg tw-ring-1 tw-ring-white/10 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-white/20" initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -10
    }} transition={{
      duration: 0.2
    }}><div className="tw-grid tw-grid-cols-4 tw-gap-2">{children}</div></motion.div>;
    $[18] = children;
    $[19] = isOpen;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11) {
    t12 = createPortal(<div className="tw-absolute tw-z-[100]" ref={dropdownRef} style={t10}><AnimatePresence mode="wait" initial={false}>{t11}</AnimatePresence></div>, document.body);
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
}